export class DynamicScriptService {
    //load script from specified location (with optional SRI hash)
    static loadExternalResource(src: string, integrity: string | undefined): Promise<void> {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;

            // If an integrity value is provided, add the integrity and crossOrigin attributes
            if (integrity) {
                script.integrity = integrity;
                script.crossOrigin = 'anonymous'; // Required for SRI checking cross-origin resources
            }
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
            document.head.appendChild(script);
        });
    }
}
